export enum WordBankCategory {
  Xfactor = 'xfactor',
  CompanyDescriptor = 'companyDescriptor',
  TalentTags = 'talentTags'
}

export enum WordBankStatus {
  Active = 'active',
  Deleted = 'deleted',
  Pending = 'pending'
}

export enum WordBankSubType {
  Academics = 'Academics',
  Pursuits = 'Pursuits',
  Leadership = 'Leadership',
  Languages = 'Languages',
  Extracurricular = 'Extracurricular'
}

export interface IWordBank {
  _id: string
  value: string
  emoji: string
  category: WordBankCategory
  subType: string
  status: WordBankStatus
}

export interface IGetWordBanksPayload {
  category: WordBankCategory
  userId?: string
}

export interface IGetWordBanksResponse {
  data: IWordBank[]
}

export interface ICreateOwnWordBankPayload {
  wordbank: {
    category: WordBankCategory
    subType?: string
    value: string
  }
}

export interface ICreateOwnWordBankResponse {
  data: IWordBank & {
    addOther: false
  }
}
